define(function (require) {
  const tpl= require('civicsViews/view_documents/t_itv_view_document.hbs');
  const ReportPropertiesModel =  require('civicsModels/report_properties_model');
  const ViewManager = require('civicsUtils/view_manager');
  const ConfirmationModal = require('civicsViews/core/confirmation/v_itv_confirmation');
  const ReportViewUtilities = require('civicsViews/view_documents/report_view_utilities');
  const AvailableFeatures = require('civicsUtils/available_features');

  return Marionette.ItemView.extend({
    template: tpl,
    ui: {
      reportLink: 'a.report-link',
      errorRegion: '.error-region'
    },
    events: {
      'click @ui.reportLink': 'linkClicked'
    },
    linkClicked:function(e){
      e.preventDefault();
      if(this.reportError) {
        return;
      }

      if(!AvailableFeatures.ReportProperties()) {
        window.open(this.model.get('link'), "_blank");
      } else {
        this.doOpenReport();
      }

    },
    doOpenReport: function() {
      ViewManager.loading(false);


      if(this.properties && this.properties.get('reportType') && this.properties.get('reportType').toLowerCase() != 'formula') {

        window.open(this.model.get('link'), "_blank");

      } else {

        if(this.properties && this.properties.get('isConfirmationRequested')) {
        //if(true) {
          this.openConfirmationModal();

        } else {
          ReportViewUtilities.processReport(this.model);
        }

      }


    },
    openConfirmationModal: function() {
      if(this.modalRegion && this.modalRegion.inst) {
        this.modalRegion.hideModal();
      }

      if(this.inModalView) {
        this.trigger('openConfirmationModal');
      } else {
        var modal = new ConfirmationModal({
          title: i18n.t('CIVICS.INSTRUMENT_DETAIL.REPORTS.CONFIRMATION_MODAL_TITLE'),
          okLabel: i18n.t('CIVICS.COMMON.OK'),
          message: i18n.t('CIVICS.INSTRUMENT_DETAIL.REPORTS.CONFIRMATION_MODAL_DESCRIPTION'),
          modalRegion: this.modalRegion,
          showCancelButton: true,
          okCallback: () => {
            ReportViewUtilities.processReport(this.model);
          }
        });

        this.modalRegion.show(modal);
        this.modalRegion.showModal();
      }
    },

    initialize: function(options) {
      this.config = options.config;
      this.portletName = options.portletName;
      this.modalRegion = options.modalRegion;
      this.inModalView = options.inModalView;

    },
    onRender: function() {
      this.ui.errorRegion.hide();
      this.properties = new ReportPropertiesModel();
      this.properties.formatUrlRoot(this.model.get('reportName'));



      if(AvailableFeatures.ReportProperties()) {
        ViewManager.loading(true);

        this.properties.fetch().done(() => {
          ViewManager.loading(false);
        }).fail((response,status,xhrResponse) => {
          ViewManager.loading(false);
          this.triggerMethod('error:loading');

          this.ui.errorRegion.show();
          this.ui.reportLink.removeAttr('href');
          this.ui.reportLink.addClass('disabled');

          this.reportError = true;
        });
      }

    },
    templateHelpers: function() {
      return {
      }
    }

  })
});
